export default "__VITE_ASSET__GVrI6sPG__"